import * as XLSX from 'xlsx';

export const CashReportExport = (data: any[], reportTime: string) => {
  const headers = [
    'User Name',
    'Total Collected Amount',
    'Received Amount',
    'Handover Amount',
    'Currently Holding',
  ];

  const rows = data.map(row => [
    row.userName,
    row.collectedAmount,
    row.receivedAmount,
    row.handedOverAmount,
    row.currentlyHolding,
  ]);

  const firstRow = [`Report generated: ${reportTime}`];

  const aoaData = [firstRow, [], headers, ...rows]; 

  const ws = XLSX.utils.aoa_to_sheet(aoaData);

  headers.forEach((_, idx) => {
    const cellRef = XLSX.utils.encode_cell({ r: 2, c: idx });
    if (ws[cellRef]) {
      ws[cellRef].s = { font: { bold: true } };
    }
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Cash Report');

  const now = new Date();
  const fileName = `Cash_Report_${now.toISOString().slice(0, 10)}.xlsx`;
  XLSX.writeFile(wb, fileName);
};
